import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Referential } from 'src/app/models/referential';
import { ServiceResponse } from 'src/app/models/service-response';
import { ClassService } from 'src/app/rest_services/class.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { TeamService } from 'src/app/rest_services/team.service';
import { VisitService } from 'src/app/rest_services/visit.service';
import {v4 as uuidv4} from 'uuid';


@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.component.html',
  styleUrls: ['./new-customer.component.css']
})
export class NewCustomerComponent implements OnInit {

  addError: string="";
  htmlYouWantToAdd:any="";
  loadingAddingCustomer:boolean=false;
  customRadioValue!: boolean;
  mobile:boolean=false;
  requiredFields: string[] = [];
  cities: any[] = [];
  services: any[] = [];
  refSectors:any[]=[];
  newCustomerRequest:any={};
  newCustomerForm!:FormGroup;
  role:any=null;comp:any=null;
  classesSubscription!: Subscription;
  classes: any;
  commercials:any[]=[];
  refCities:any[]=[];
  commercialsSubscriptions!: Subscription;
  commercialFullName:any;
  token : any = '';

  constructor(
    private fb: FormBuilder,
    private visitService:VisitService,
    private settingsService:SettingsService,
    private msSector : MsSectorService,
    private classService: ClassService,
    private teamService: TeamService,
    private router: Router,
    private customersService :CustomersService,
    private location : Location
  ) { }

  ngOnInit(): void {
    this.getConfig();
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.comp=localStorage.getItem("comp");
      this.commercialFullName=localStorage.getItem("fullname");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.comp=sessionStorage.getItem("comp");
      this.commercialFullName=sessionStorage.getItem("fullname");
    }
    
    this.newCustomerForm = this.fb.group({
      'social': ['', [Validators.required, Validators.maxLength(50)]],
      'sector' : ['',  Validators.required],
      'agent' : [''],
      'email' : ['', [Validators.email]],
      'city': [''],
      'zip' : [''],
      'address' : [''],
      'phone' : ['', [Validators.pattern(/^\d{10}$/)]],
      'skype' : [''],
      'class' : [''],
      'commercial': [''],
      'city_label':[''],
      'selectedCity':[''],
      'extraSite':[''],
      'selectedSite':[''],
      'service': [''],
      'cmrc':[this.commercialFullName],
      'logo':['']
    });

    this.newCustomerForm.valueChanges.subscribe(() => {
      this.requiredFields = [];

      const socialControl = this.newCustomerForm.get('social');
      if (socialControl && socialControl.invalid) {
        this.requiredFields.push('social');
      }
    
      const sectorControl = this.newCustomerForm.get('sector');
      if (sectorControl && sectorControl.invalid) {
        this.requiredFields.push('sector');
      }
    
      //const cityControl = this.newCustomerForm.get('city');
      if (this.cities.length==0) {
        this.requiredFields.push('city');
      }
    });

    var glob = this;
    var blocActions = this.htmlYouWantToAdd;
    $(document).ready(function() {
      $('#citiesSelect').change(function() {
        var value = $(this).val();
        var elt = glob.cities.find((el:any) => el.uuid == value);
        var uuid = $("option:selected", this).attr("ud");
        var city = {
          name: $( "#citiesSelect option:selected" ).text(),
          sites: [],
          uuid: uuid
        };
        let index = -1;
        if (elt !== undefined) {
          index = glob.cities.findIndex((d :any) => d.name == elt.city);
        }
        if (index < 0 && value !== "") {
          var alreadySelected = glob.cities.some((item: any) => item.uuid === uuid);
          if (!alreadySelected) {
            const existingCity = glob.cities.find((item: any) =>
              glob.compareStringsIgnoringAccents(item.name.toString(), city.name.toString())
            );
            if (!existingCity) {
              glob.cities.push(city);
              glob.cityAdded = glob.cities.length > 0;
              setTimeout(function() {
                $('#citiesSelect').val("");
              }, 500);
            }
          } else {
            glob.addError = "La ville que vous avez sélectionné existe déjà pour ce compte client !";
            $("#city_not_added_select").removeClass("d-none");
            $('#citiesSelect').val("");
            setTimeout(()=>{
              $("#city_not_added_select").addClass("d-none");
            }, 4000);
          }
        }         
        // Update the 'city' form control's required attribute based on the cities array
        const cityFormControl = $('#citiesSelect')[0] as HTMLSelectElement;
        cityFormControl.required = glob.cities.length === 0;

        // Update the validity of the 'city' form control
        cityFormControl.setCustomValidity(cityFormControl.validity.valid ? '' : 'Please select a city.');
      });

      // Get references to the file input and imageDiv elements
    const logoInput = document.getElementById('logoInput') as HTMLInputElement;
    const imageDiv = document.getElementById('imageDiv');

    // Add an event listener to the file input
    logoInput.addEventListener('change', (event) => {
        const selectedFile = logoInput.files?.[0]; // Use the logoInput reference

        // Check if a file was selected
        if (selectedFile) {
            // Read the selected file as a data URL
            const reader = new FileReader();
            reader.onload = (e) => {
              const logoDataUrl = e.target?.result as string; // Use optional chaining
              // Create an <img> element and set its src attribute
              const imgElement = document.createElement('img');
              imgElement.src = logoDataUrl;
              imgElement.alt = 'Selected Logo';
              imgElement.style.width = '100px';
              // imgElement.style.marginLeft = 'auto';
              // imgElement.style.display = 'block';
              imgElement.style.border = '2px solid #000'; // Add a border
              if(imageDiv){
                // Clear any existing content in the imageDiv and append the image
              imageDiv.innerHTML = '';
              imageDiv.appendChild(imgElement);
              }
            };
            reader.readAsDataURL(selectedFile);
        } else {
            // Clear the imageDiv if no file is selected
            if (imageDiv)imageDiv.innerHTML = '';
        }
    });
    });

    this.getSectors();
    this.getClasses();
    this.getCities();
    this.getCommercials();
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getSectors(){    
    this.msSector.getSectors(this.token);
    this.msSector.sectorsSubject.subscribe(
      ( data: any ) => {
        if(data.status=="200 OK"){
          this.refSectors = data.sectors;
        }
      },
    )  
  }

  // getSectors(){
  //   this.visitService.getSectors();
  //   this.visitService.sectorsSubject.subscribe(
  //     ( data: any ) => {
  //       if(data.code=="d9cc2e7dc2cf71242be86ab1ad241752"){
  //         this.refSectors = data.sectors;
  //       }
  //     },
  //   )  
  // }
  getClasses(){
    this.classesSubscription = this.classService.getClasses().subscribe(
      (data: ServiceResponse) => {
        if(data.code == "7cd8d69b7048301e37f4ddaf4959218c"){
          this.classes = data.classes?data.classes:[];
        }    
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  getCommercials() {
    this.commercialsSubscriptions = this.teamService.getCommercials().subscribe(
      (resp: ServiceResponse) => {
        if(resp.code == "b1f37eec383fcada527079602ac178b3"){
          this.commercials = resp.commercials;
        }
      },
      (err: any) => {
        console.log(err);
        
      }
    );
  }
  getCities(){
    this.newCustomerForm.controls.city.setValue("");
    this.customersService.getRefCities();
    this.customersService.refCitiesSubject.subscribe(
      ( data: any ) => {
        if(data.code=="9d0907561104ccc6b9d188f036bd358c"){
          this.refCities = data.cities;          
        }
      },
    )  
  }
  cityAdded:any =false;
   //add a new city
   newCity() {
    const cityFormValue = this.newCustomerForm?.get('city_label')?.value;
    if (cityFormValue) {
      const existingCity = this.cities.find((city: any) =>
        this.compareStringsIgnoringAccents(city.name.toString(), cityFormValue.toString())
      );
      const existingRefCity = this.refCities.find((city: any) =>
        this.compareStringsIgnoringAccents(city.city.toString(),cityFormValue.toString())
      );
      if (existingCity !=undefined) {
            this.addError = "La ville que vous avez saisi existe déjà pour ce compte client !";
            $("#city_not_added_input").removeClass("d-none");
            setTimeout(()=>{
              $("#city_not_added_input").addClass("d-none");
            }, 4000);
        //this.cityAdded = this.customer_cities.length > 0;
      }if (existingRefCity != undefined) {
        this.addError = "La ville existe déjà. Veuillez la sélectionner dans la liste déroulante !";
        $("#city_not_added_input").removeClass("d-none");
        setTimeout(()=>{
          $("#city_not_added_input").addClass("d-none");
        }, 4000);
      } else if (!existingCity) {
        const capitalizedCity = cityFormValue.charAt(0).toUpperCase() + cityFormValue.slice(1).toLowerCase();
        const newCity = {
          name: capitalizedCity,
          uuid: uuidv4(),
          sites: []
        };
        this.cities.push(newCity);
        this.cityAdded = this.cities.length > 0;
      }
    }
  } 

  removeCity(city: any) {
    const cityIndex = this.cities.findIndex((c: any) => c.uuid === city.uuid);
    if (cityIndex !== -1) {
      const cityToRemove = this.cities.splice(cityIndex, 1)[0];
  
      // Remove all sites associated with the deleted city
      const siteIndicesToDelete = this.sites
        .filter((site: any) => site.city_uuid === cityToRemove.uuid)
        .map((site: any) => this.sites.indexOf(site))
        .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
      siteIndicesToDelete.forEach((siteIndex) => {
        const deletedSite = this.sites.splice(siteIndex, 1)[0];
  
        // Remove all services associated with the deleted site
        const serviceIndicesToDelete = this.services
          .filter((service: any) => service.site_uuid === deletedSite.site_uuid)
          .map((service: any) => this.services.indexOf(service))
          .sort((a, b) => b - a); // Sort in reverse order to avoid index issues
  
        serviceIndicesToDelete.forEach((serviceIndex) => {
          this.services.splice(serviceIndex, 1);
        });
      });
      this.cityAdded = this.cities.length > 0;
    }
  }
  
  sites:any[]=[];
   // New function to add a new site to a city
   newSite() {
    const selectedCityId = this.newCustomerForm?.get('selectedCity')?.value;
    const siteFormValue = this.newCustomerForm?.get('extraSite')?.value;
    const addressFormValue = this.newCustomerForm?.get('address')?.value;

    if (selectedCityId && siteFormValue) {
      const selectedCity = this.cities.find((city: any) => city.uuid === selectedCityId);
      if (selectedCity) {
        const existingSite = this.sites.find((site: any) => site.site_name === siteFormValue && site.city_uuid === selectedCityId);
        if (!existingSite) {
          const newSite = {
            site_name: siteFormValue,
            site_uuid: uuidv4(),
            city_uuid: selectedCityId,
            site_address: addressFormValue, // Add address to newSite
            services: []
          };
          this.sites.push(newSite);
          selectedCity.sites.push(newSite);
          this.newCustomerForm?.get('extraSite')?.setValue('');
          this.newCustomerForm?.get('address')?.setValue('');
          $("#selectedCities").val("");
          // this.siteAdded = this.sites.length > 0;
        }else{
          this.addError = "Le site que vous avez saisi existe déjà pour ce compte client !";
          $("#site_not_added").removeClass("d-none");
          setTimeout(()=>{
            $("#site_not_added").addClass("d-none");
          }, 4000);
         }
      }
    }
  }

  removeSite(site: any, city: any) {
    const siteIndex = this.sites.findIndex((s: any) => s.site_uuid === site.site_uuid);
    if (siteIndex !== -1) {
      this.sites.splice(siteIndex, 1);
      const cityIndex = city.sites.findIndex((s: any) => s.site_uuid === site.site_uuid);
      if (cityIndex !== -1) {
        city.sites.splice(cityIndex, 1);
        // Remove the related services for the deleted site
        const relatedServices = site.services;
        for (const service of relatedServices) {
          const serviceIndex = site.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
          if (serviceIndex !== -1) {
            site.services.splice(serviceIndex, 1);
          }
          const servicesIndex = this.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
          if (servicesIndex !== -1) {
            this.services.splice(servicesIndex, 1);
          }
        }
      }
    }
  }

  // Function to add a new service to a site
  addService() {
    const selectedSiteId = this.newCustomerForm?.get('selectedSite')?.value;
    const serviceName = this.newCustomerForm?.get('service')?.value;
  
    if (selectedSiteId && serviceName) {
      const selectedSite = this.sites.find((site: any) => site.site_uuid === selectedSiteId);
      if (selectedSite) {
        const existingService = selectedSite.services.find((service: any) => service.service_name === serviceName);
        if (!existingService) {
          const newService = {
            service_name: serviceName,
            service_uuid: uuidv4(),
            site_uuid:selectedSiteId
          };
          selectedSite.services.push(newService);
          this.services.push(newService);
          this.newCustomerForm?.get('service')?.setValue('');
          $("#selectedSites").val("");
        }else{
          this.addError = "Le service que vous avez saisi existe déjà pour ce compte client !";
        $("#service_not_added").removeClass("d-none");
        setTimeout(()=>{
          $("#service_not_added").addClass("d-none");
        }, 4000);
         }
      }
    }    
  }

  getCityName(cityUuid: string): string {
    const city = this.cities.find((c: any) => c.uuid === cityUuid);
    return city ? city.name : 'Unknown City'; // Replace 'Unknown City' with your desired default value.
  }
  

  // Function to remove a service from a site
  removeService(service: any, site: any) {
    const serviceIndex = site.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
    if (serviceIndex !== -1) {
      // Remove the service from the site's services array
      site.services.splice(serviceIndex, 1);
  
      // Update the services array to remove the service
      const globalServiceIndex = this.services.findIndex((s: any) => s.service_uuid === service.service_uuid);
      if (globalServiceIndex !== -1) {
        this.services.splice(globalServiceIndex, 1);
      }
    }
  }
  

  compareStringsIgnoringAccents(str1: string, str2: string): boolean {
    if (!str1 || !str2) {return false;}
    const normalizedStr1 = str1.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalizedStr2 = str2.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedStr1.toLowerCase() === normalizedStr2.toLowerCase();
  }

  selectedLogo: File | null = null;
  onLogoSelect(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedLogo = inputElement.files[0];
    }
  }

  addNewCustomer(){
    $("html, body").animate({ scrollTop: 0 });
    var valuesNewCustomerForm = this.newCustomerForm.value;
    let customerClass = new Referential();
    customerClass.uuid = valuesNewCustomerForm.class;
    this.loadingAddingCustomer = true;
    if(this.newCustomerForm.valid){
      this.newCustomerRequest = {
        social_reason:valuesNewCustomerForm.social,
        customer_sector:valuesNewCustomerForm.sector,
        represented_by:valuesNewCustomerForm.agent,
        customer_email:valuesNewCustomerForm.email,
        customer_cities:this.cities,
        customer_zip:valuesNewCustomerForm.zip,
        //customer_address:valuesNewCustomerForm.address,
        customer_phone: valuesNewCustomerForm.phone,
        customer_skype: valuesNewCustomerForm.skype,
        customer_refClass: customerClass,
        customerCommercial: valuesNewCustomerForm.commercial,
        customer_sites:this.sites,
        customer_services: this.services
      };
      if (this.selectedLogo) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const logoDataUrl = e.target?.result as string;
            this.newCustomerRequest.customer_logo = logoDataUrl.split(',')[1];
            this.continueWithCustomerCreation();
        };
        reader.readAsDataURL(this.selectedLogo);
    } else {
        this.continueWithCustomerCreation();
    }
    }
  }

  continueWithCustomerCreation() {
    this.customersService.newCustomerRequest = this.newCustomerRequest;
      this.customersService.newCustomer();
      this.newCustomerRequest=this.customersService.newCustomerSubject.subscribe(
        ( data: any ) => {
          if(data.code=="321b6e3b3785131f5cee153737dba9a2"){
            this.loadingAddingCustomer = false;
            this.newCustomerForm.reset();
            this.newCustomerForm.controls['sector'].setValue("", {onlySelf: true});
            this.newCustomerForm.controls['city'].setValue("", {onlySelf: true});
            this.newCustomerForm.controls['commercial'].setValue("", {onlySelf: true});
            this.cities=[];
            $("#customer_added").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              // Navigate to the customer page with the newly created customer's uuid
              const newCustomerUuid = data.customer.customer;
              const customerPageUrl = '/customer/fromshow;cs=' + newCustomerUuid;
              this.router.navigateByUrl(customerPageUrl);
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_added").hide();
            }, 2000);
            //this.allCustomers.push(data.customer);
            //this.getCustomersIndicators();
          } else if (data.code=="06c61e9f990cce9353c3064f99f6ec42"){
            this.addError ="Client existe dèja"; 
            this.loadingAddingCustomer = false;
            $("#customer_not_added").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_not_added").hide();
            }, 8000)
          } else {
            this.addError ="Client non ajouté"; 

            this.loadingAddingCustomer = false;
            $("#customer_not_added").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#customer_not_added").hide();
            }, 8000);
          }
        },
        (err: any) => {
          this.addError ="Client non ajouté"; 
          this.loadingAddingCustomer = false;
          $("#customer_not_added").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#customer_not_added").hide();
          }, 8000);
        }
      )
  }

  back(){
    this.location.back();
  }
}
